import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="inner">
      <nav className="cnb">
        <ul className="cnb-list">
          <li>
            <Link to="/intr" className="cnb-list-inner">
              <dl>
                <dt>
                  <h2>소개</h2>
                </dt>
                <dd>
                  <div className="box-txt">
                    올바른 선택을 할 수 있는 방법을 제시하며 빠르고 합리적인 비용 등을 통하여 의뢰인이 원하는 최상의 만족을 얻도록 최선을 다할 것을 약속드립니다.
                  </div>
                  <button className="btn-s">자세히보기</button>
                </dd>
              </dl>
            </Link>
          </li>
          <li>
            <Link to="/busi" className="cnb-list-inner">
              <dl>
                <dt>
                  <h2>주요 업무</h2>
                </dt>
                <dd>
                  <div className="box-txt">
                    <ul>
                      <li>상속/상속포기/한정승인</li>
                      <li>민사소송 <span className="hide-L">(지급명령, 내용증명, 소장, 답변서, 준비서면)</span></li>
                      <li>민사집행 <span className="hide-L">(가압류, 가처분, 채권압류 및 추심, 전부명령)</span></li>
                      <li>개인회생/파산</li>
                      <li>공탁/경매</li>
                      <li>기업 법률자문 및 법인등기 <span className="hide-L">(법률자문, 법인설립 및 변경등기)</span></li>
                    </ul>
                  </div>
                  <button className="btn-s">자세히보기</button>
                </dd>
              </dl>
            </Link>
          </li>
          <li>
            <div className="cnb-list-inner">
              <dl>
                <dt>
                  <h2>상담 신청</h2>
                </dt>
                <dd>
                  <div className="box-txt">
                    <ul>
                      <li>전화 : 02-448-2207</li>
                      <li>팩스 : 02-449-2207</li>
                      <li>이메일 : lawbareun@naver.com</li>
                    </ul>
                  </div>
                </dd>
              </dl>
            </div>
          </li>
          <li>
            <Link to="/loca" className="cnb-list-inner">
              <dl>
                <dt>
                  <h2>오시는 길</h2>
                </dt>
                <dd>
                  <div className="box-txt">
                    서울 송파구 법원로8길 13 3층 315호(문정동, 문정헤리움써밋타워)
                  </div>
                  <button className="btn-s">자세히보기</button>
                </dd>
              </dl>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Home;
